import { Button } from "@chakra-ui/react"
import { useNavigate } from "@tanstack/react-router"
import { useEffect, useState } from "react"
import { CartService } from "../client"

const CheckoutButton: React.FC = () => {
  const navigate = useNavigate()
  // const [cart, setCart] = useState<CartSchema | null>(null)
  const [itemCount, setItemCount] = useState<number>(0)

  useEffect(() => {
    const fetchCart = async () => {
      try {
        const cartData = await CartService.getCart() // Fetch cart data
        // setCart(cartData)
        setItemCount(cartData.items.length)
      } catch (error) {
        console.error("Failed to fetch cart data:", error)
      }
    }

    fetchCart()
  }, [])

  if (itemCount < 1) {
    return <Button variant="disabled">Checkout</Button>
  }

  return (
    <Button
      variant="emphasis"
      onClick={() => {
        window.parent.postMessage({ navigateTo: "orderinfo" }, "*")
        navigate({ to: "/orderinfo" })
      }}
    >
      Checkout
    </Button>
  )
}

export default CheckoutButton
